import { Button, LinkButton } from '@sorrem-client/ui/components';
import { AccessScreen } from './AccessScreen';
import { DISCORD_INVITE_URL } from './links';
import styles from './LoginPage.module.scss';

interface LoginPageProps {
    buttonLabel: string;
    onContinue: () => void;
}

export function LoginPage({ buttonLabel, onContinue }: LoginPageProps): JSX.Element {
    return (
        <AccessScreen
            ariaLabel="Login panel"
            kicker="Sorrem - Closed Alpha"
            title="The Veil Remembers What Mortals Forgot"
            subtitle={(
                <>
                    Then it tore something open in you. Now you can walk into the Crucibles where its
                    memories take shape, and carry the truth back out.
                </>
            )}
            after={(
                <>
                    <div className={styles.joinPrompt}>
                        <p>Not a tester yet? Alpha invites are handed out in the Sorrem Discord.</p>
                        <LinkButton href={DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer" variant="secondary" size="small">
                            Join the Discord
                        </LinkButton>
                    </div>
                    <p className={styles.footnote}>Alpha characters and progress are test data and may be reset.</p>
                </>
            )}
        >
            <Button className={styles.continueButton} type="button" prominent onClick={onContinue}>
                {buttonLabel}
            </Button>
            <p className={styles.formNote}>
                The alpha is invite-only. Sign in with the Discord account that has the tester role.
            </p>
        </AccessScreen>
    );
}
